import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _unary from 'lodash/unary';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { fieldsObjectOf, valuesObjectOf, errorsObjectOf, rowOneOfType } from '../../utils/propTypes';
import styles from './fieldLayout.module.scss';
function getSizeClassName(size) {
  return size ? styles["flex-item-".concat(size)] : '';
}
var FieldLayout = /*#__PURE__*/function (_PureComponent) {
  _inherits(FieldLayout, _PureComponent);
  var _super = _createSuper(FieldLayout);
  function FieldLayout(props) {
    var _this;
    _classCallCheck(this, FieldLayout);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "renderRow", function (row, className) {
      if (typeof row === 'string') {
        return _this.renderField(row, className);
      }
      return /*#__PURE__*/React.createElement("div", {
        id: row.id,
        className: cx(styles.columnContainer, row.className)
      }, row.columns.map(_this.renderColumn));
    });
    _defineProperty(_assertThisInitialized(_this), "renderColumn", function (column, index) {
      if (typeof column === 'string') {
        return _this.renderField(column);
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: cx(styles.rowContainer, column.className)
      }, column.rows.map(_this.unaryRenderRow));
    });
    _this.unaryRenderRow = _unary(_this.renderRow);
    return _this;
  }
  _createClass(FieldLayout, [{
    key: "renderField",
    value: function renderField(fieldId) {
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var props = this.props;
      var field = props.fields[fieldId];
      var Field = field.renderer;
      var renderOptions = field.renderOptions || EMPTY_OBJECT;
      var fieldClassName = "".concat(getSizeClassName(renderOptions.size), " ").concat(renderOptions.fieldClassName || '', " ").concat(styles.fieldC, " ").concat(className);
      if (!field || !Field) return null;

      /*
        Can be leveraged to remount the field so that the state of the field can be reset
      */
      var fieldKey = renderOptions.fieldKey || fieldId;
      return /*#__PURE__*/React.createElement(Field, _extends({}, renderOptions, {
        fieldClassName: fieldClassName,
        id: fieldId,
        key: fieldKey,
        error: props.errors[fieldId],
        value: props.values[fieldId],
        warning: props.warnings[fieldId],
        onAction: props.onAction
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var row = this.props.row;
      return this.renderRow(row, styles.columnContainer);
    }
  }]);
  return FieldLayout;
}(PureComponent);
_defineProperty(FieldLayout, "displayName", 'Row');
FieldLayout.propTypes = {
  row: rowOneOfType,
  fields: fieldsObjectOf,
  values: valuesObjectOf,
  errors: errorsObjectOf,
  onAction: PropTypes.func.isRequired
};
FieldLayout.defaultProps = {
  row: EMPTY_ARRAY,
  fields: EMPTY_OBJECT,
  values: EMPTY_OBJECT,
  errors: EMPTY_OBJECT
};
export default FieldLayout;